<div class="container mt-4">
  <div class="card shadow-sm">
    <div class="table-responsive p-3">

      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h4 class="mb-0">Microsoft Dynamic Ammendment Form</h4>
      </div>

      <!-- Employee Table -->
      <table class="table table-bordered table-hover">
        <thead class="table-dark">
          <tr>
            <th>#</th>
            <th>Action</th>
            <th>Employee ID</th>
            <th>Full Name</th>
            <th>Designation</th>
            <th>Location</th>
            <th>Department</th>
            <th>Requester</th>
            <th>Checker</th>
            <th>Approver</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let emp of appservice.Microsoft_Rejectiongrid; let i = index">
            <td>{{ i + 1 }}</td>

            <!-- Action Dropdown -->
            <td>
              <button 
  class="btn btn-secondary btn-sm" 
  type="button" 
  (click)="verifyemployee(emp.MD_EmployeeId)">
  Verify
</button>
            </td>

            <!-- Data Columns -->
            <td>{{ emp.MD_EmployeeId }}</td>
            <td>{{ emp.MD_Fullname }}</td>
            <td>{{ emp.MD_Designation }}</td>
            <td>{{ emp.MD_Grade }}</td>
            <td>{{ emp.MD_Department }}</td>
            <td>{{ emp.MD_Createdby }}</td>
            <td>{{ emp.MD_ReporterName }}</td>
            <td>{{ emp.MD_final_approvedby }}</td>
          </tr>
        </tbody>
      </table>

    </div>
  </div>
</div>
